import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';


const VideoCard = ({ video, onPlay, onBookmark }) => {
  const [isHovered, setIsHovered] = useState(false);

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  const getCategoryColor = (category) => {
    const colors = {
      'Procedures': 'bg-primary text-primary-foreground',
      'Equipment': 'bg-accent text-accent-foreground',
      'Safety': 'bg-error text-error-foreground',
      'Software': 'bg-secondary text-secondary-foreground',
      'Clinical': 'bg-success text-success-foreground',
      'Administration': 'bg-warning text-warning-foreground'
    };
    return colors?.[category] || 'bg-muted text-muted-foreground';
  };

  return (
    <div
      className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-interactive transition-all duration-300 cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onPlay(video)}
    >
      <div className="relative overflow-hidden" style={{ height: '180px' }}>
        <Image
          src={video?.thumbnail}
          alt={video?.thumbnailAlt}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
          <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center">
            <Icon name="Play" size={32} color="#FFFFFF" />
          </div>
        </div>
        <div className="absolute top-2 right-2 px-2 py-1 bg-black/70 text-white text-xs font-medium rounded">
          {formatDuration(video?.duration)}
        </div>
        {video?.isNew && (
          <div className="absolute top-2 left-2 px-2 py-1 bg-error text-error-foreground text-xs font-semibold rounded">
            NOUVEAU
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="text-base font-semibold text-foreground line-clamp-2 flex-1">
            {video?.title}
          </h3>
          <button
            onClick={(e) => {
              e?.stopPropagation();
              onBookmark(video?.id);
            }}
            className="p-1 hover:bg-muted rounded transition-colors duration-200"
          >
            <Icon
              name={video?.isBookmarked ? 'Bookmark' : 'BookmarkPlus'}
              size={20}
              color={video?.isBookmarked ? 'var(--color-primary)' : 'currentColor'}
            />
          </button>
        </div>

        <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
          {video?.description}
        </p>

        <div className="flex items-center justify-between">
          <span className={`px-2 py-1 text-xs font-medium rounded ${getCategoryColor(video?.category)}`}>
            {video?.category}
          </span>
          <span className="text-xs text-muted-foreground">
            {video?.views} vues
          </span>
        </div>

        {video?.progress > 0 && (
          <div className="mt-3">
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs text-muted-foreground">Progression</span>
              <span className="text-xs font-medium text-foreground">{video?.progress}%</span>
            </div>
            <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
              <div
                className="h-full bg-primary transition-all duration-300"
                style={{ width: `${video?.progress}%` }}
              />
            </div>
          </div>
        )}

        {video?.isCompleted && (
          <div className="mt-3 flex items-center gap-2 text-success">
            <Icon name="CheckCircle2" size={16} />
            <span className="text-xs font-medium">Terminé</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoCard;